import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const viewIntentRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-view-intent',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?',
};
